import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    folios: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const GET_ALL_FOLIOS = 'GET_ALL_FOLIOS'
const GET_FOLIOS_BY_ID = 'GET_FOLIOS_BY_ID'
const ACTUALIZAR_FOLIO = 'ACTUALIZAR_FOLIO'

//*******************************************************************************************************************


//METODOS
export const obtenerFolios = createAsyncThunk(
    GET_ALL_FOLIOS,
    async () => {
        try {
            const fullUrl = host + `FoliosUI/obtenerFolios`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFolioByID = createAsyncThunk(
    GET_FOLIOS_BY_ID,
    async (idfolio) => {
        try {
            const fullUrl = host + `FoliosUI/obtenerFolioByID/${idfolio}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFolio = createAsyncThunk(
    ACTUALIZAR_FOLIO,
    async (data) => {
        try {
            const fullUrl = host + `FoliosUI/actualizarFolio`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosFoliosUISlice = createSlice({

    name: 'metodosFoliosUISlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerFolios.fulfilled]: (state, { payload }) => {
            state.folios = payload.data.data
        },
        [obtenerFolioByID.fulfilled]: (state, { payload }) => {
            state.folios = payload.data.data
        },
        [actualizarFolio.fulfilled]: (state, { payload }) => {
            state.folios = payload.data.data
        },
    },

})

export const { } = metodosFoliosUISlice.actions
export const FoliosUIReducer = metodosFoliosUISlice.reducer